import { ComponentType } from 'react';

import En from '@assets/locales/En.svg?react';
import Kk from '@assets/locales/Kk.svg?react';
import Ru from '@assets/locales/Ru.svg?react';

import { Locale } from 'v2/constants';

interface LocaleConfig {
  ref: string;
  icon: ComponentType;
}

// refer to https://nucleoapp.com/svg-flag-icons for another country flags if needed
export const localeToUIMap: Record<Locale, LocaleConfig> = {
  [Locale.ru_RU]: {
    ref: 'Russian',
    icon: Ru,
  },
  [Locale.en_US]: {
    ref: 'English',
    icon: En,
  },
  [Locale.kk_KZ]: {
    ref: 'Kazakh',
    icon: Kk,
  },
};
